import { Link } from "react-router-dom";
import React, { useState } from "react";
import config from './Config';
import { LEGAL_ENTITY } from './legalInfo';
import { dedupedFetch } from './functions/dedupedFetch';
import Loader from "./pages/Loader";
import homepic from './pages/images/home.png';

export default function Footer() {
    const [loading, setLoading] = useState(false);

    return (
        <footer className="foot-v2">
            <Loader show={loading} />

            <div className="foot-v2-main">
                <div className="foot-v2-brand">
                    <img src={homepic} alt="Mermadic logo" className="foot-v2-logo" />
                    <p className="foot-v2-tagline">
                        Your complete container platform —<br />
                        run jobs, deploy services, automate pipelines,<br />
                        all through your cluster's dedicated API.
                    </p>
                    <div className="foot-v2-social">
                        <a
                            href="https://www.linkedin.com/company/136333980/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Mermadic on LinkedIn"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                                <path fill="currentColor" d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.73V1.73C24 .77 23.21 0 22.23 0z" />
                            </svg>
                        </a>
                        <a
                            href="https://x.com/MermadicHQ"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Mermadic on X"
                        >
                            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                                <path fill="currentColor" d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.22-6.82-5.97 6.82H1.66l7.73-8.84L1.25 2.25h6.83l4.71 6.23 5.45-6.23zm-1.16 17.52h1.83L7.01 4.06H5.04l12.04 15.71z" />
                            </svg>
                        </a>
                    </div>
                </div>

                <div className="foot-v2-col">
                    <h4>Product</h4>
                    <ul>
                        <li><Link to="/kubernetes-without-aws">Kubernetes without AWS</Link></li>
                        <li><Link to="/batch-jobs">Docker batch jobs</Link></li>
                        <li><Link to="/gpu-jobs">GPU jobs</Link></li>
                        <li><Link to="/pricing">Pricing</Link></li>
                    </ul>
                </div>

                <div className="foot-v2-col">
                    <h4>Resources</h4>
                    <ul>
                        <li><Link to="/documentation">Documentation</Link></li>
                        <li><Link to="/pricing">Pricing</Link></li>
                        <li><Link to="/documentation">Dedicated API Reference</Link></li>
                        <li><Link to="/terms">Terms of Service</Link></li>
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                    </ul>
                </div>

                <div className="foot-v2-col">
                    <h4>Account</h4>
                    <ul>
                        <li><Link to="/login">Log in</Link></li>
                        <li><Link to="/signup">Sign up free</Link></li>
                        <li><Link to="/account">My Account</Link></li>
                        <li><Link to="/contact">Contact us</Link></li>
                    </ul>
                </div>
            </div>

            <div className="foot-v2-bottom">
                <span>© 2026 {LEGAL_ENTITY}. All rights reserved.</span>
                <span className="foot-v2-bottom-links">
                    <Link to="/pricing">Pricing</Link>
                    <Link to="/documentation">Docs</Link>
                    <Link to="/terms">Terms</Link>
                    <Link to="/privacy">Privacy</Link>
                </span>
            </div>

            <div className="foot-v2-pattern" aria-hidden="true" />
        </footer>
    );
}
